/**
 * Font cho khối văn bản canvas — khớp với Google Fonts đã tải trong public-landing.html.
 * `stack` là giá trị CSS `font-family` lưu trong config.
 */
export type LandingCanvasFontOption = {
  id: string;
  label: string;
  /** Chuỗi CSS đầy đủ, ví dụ "'Be Vietnam Pro', sans-serif". Rỗng = mặc định trang */
  stack: string;
};

export const LANDING_CANVAS_FONT_OPTIONS: LandingCanvasFontOption[] = [
  { id: 'inherit', label: 'Mặc định (theo trang)', stack: '' },
  { id: 'be-vietnam-pro', label: 'Be Vietnam Pro', stack: "'Be Vietnam Pro', sans-serif" },
  { id: 'inter', label: 'Inter', stack: "'Inter', sans-serif" },
  { id: 'plus-jakarta-sans', label: 'Plus Jakarta Sans', stack: "'Plus Jakarta Sans', sans-serif" },
  { id: 'dm-sans', label: 'DM Sans', stack: "'DM Sans', sans-serif" },
  { id: 'space-grotesk', label: 'Space Grotesk', stack: "'Space Grotesk', sans-serif" },
  { id: 'montserrat', label: 'Montserrat', stack: "'Montserrat', sans-serif" },
  { id: 'poppins', label: 'Poppins', stack: "'Poppins', sans-serif" },
  { id: 'nunito', label: 'Nunito', stack: "'Nunito', sans-serif" },
  { id: 'quicksand', label: 'Quicksand', stack: "'Quicksand', sans-serif" },
  { id: 'raleway', label: 'Raleway', stack: "'Raleway', sans-serif" },
  { id: 'mulish', label: 'Mulish', stack: "'Mulish', sans-serif" },
  { id: 'lexend', label: 'Lexend', stack: "'Lexend', sans-serif" },
  { id: 'comfortaa', label: 'Comfortaa', stack: "'Comfortaa', sans-serif" },
  { id: 'cabin', label: 'Cabin', stack: "'Cabin', sans-serif" },
  { id: 'signika', label: 'Signika', stack: "'Signika', sans-serif" },
  { id: 'open-sans', label: 'Open Sans', stack: "'Open Sans', sans-serif" },
  { id: 'lato', label: 'Lato', stack: "'Lato', sans-serif" },
  { id: 'roboto', label: 'Roboto', stack: "'Roboto', sans-serif" },
  { id: 'source-sans-3', label: 'Source Sans 3', stack: "'Source Sans 3', sans-serif" },
  { id: 'noto-sans', label: 'Noto Sans', stack: "'Noto Sans', sans-serif" },
  { id: 'merriweather', label: 'Merriweather', stack: "'Merriweather', serif" },
  { id: 'playfair-display', label: 'Playfair Display', stack: "'Playfair Display', serif" },
  { id: 'oswald', label: 'Oswald', stack: "'Oswald', sans-serif" },
  { id: 'dancing-script', label: 'Dancing Script', stack: "'Dancing Script', cursive" },
  { id: 'pacifico', label: 'Pacifico', stack: "'Pacifico', cursive" },
];

export function canvasFontIdFromStack(stack: string | undefined): string {
  const s = (stack ?? '').trim();
  const hit = LANDING_CANVAS_FONT_OPTIONS.find((o) => o.stack === s);
  return hit?.id ?? 'inherit';
}
